import {
  ProcessElsRawScanTask,
  ProcessPointCloudFlsRawTask,
} from "@custom-types/sdb-background-tasks-types";

/**
 * @returns number Epoch milisecond of the latest uploaded scan or 0.
 */
export function latestUpload(processScanTasks: (ProcessElsRawScanTask | ProcessPointCloudFlsRawTask)[]): number {
  // We cannot use the "createdAt" attribute of the scan entities to determine the upload time,
  // since it's used for the recording time of the scan.
  // Until there is a dedicated attribute for the upload time (SMETA-1540), we check the processing tasks instead.
  // Using this approach, there's the problem that, when uploading some additional scans, for the short period between
  // the end of the Upload state and the beginning of the Processing state, the old further advanced state gets shown
  // again. An alternative approach using projectApiClient.getCaptureTreeForRegistrationRevision resulted in the same
  // problem.
  const scanTaskNewest = processScanTasks.length ? processScanTasks[0] : undefined;
  return scanTaskNewest ? (new Date(scanTaskNewest.createdAt)).getTime() : 0;
}
